<template>
  <div>
    <div class="sm:flex sm:items-start">
      <div class="text-left w-full">
        <h3
          class="text-lg leading-6 font-medium text-gray-900"
          id="modal-headline"
        >
          Update State Restriction Status
        </h3>
        <div class="mt-2 text-center">
          <p v-if="saving" class="text-sm leading-5 text-gray-500">
            Checking order for state restrictions...
            <LoadingSpinner class="text-gray-400 inline-block" />
          </p>
          <p v-else class="text-sm leading-5 text-gray-500">
            {{ response }}
            <icon
              set="solid"
              name="check"
              class="h-5 w-5 text-green-500 inline-block"
            />
          </p>
        </div>
      </div>
    </div>

    <div v-if="isError" class="sm-flex rounded-md bg-red-50 relative mt-4 p-2">
      <div class="flex">
        <icon
          set="solid"
          name="x-circle"
          class="flex-shrink-0 h-5 w-5 text-red-400"
        />
        <div class="ml-3">
          <h3 class="text-sm leading-5 font-medium text-red-800">
            {{ errorMsg }}
          </h3>
          <div class="mt-2 text-sm leading-5 text-red-700">
            <div v-if="errorMsg">
              <ul id="example-1">
                <li v-for="(item, index) in invalidItems" :key="index">
                  {{ item.variantId }}
                </li>
              </ul>
            </div>
            <div v-else>
              If you continue to have problems please contact support.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
      <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <Button
          class="btn btn-white"
          v-on:click-handler="$emit('onClose', true)"
        >
          Close
        </Button>
      </span>
    </div>
  </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Button from "@/components/elements/Button.vue";

const OrderApi = ApiFactory.get("orders");

export default {
  props: {},
  data() {
    return {
      saving: true,
      isError: false,
      errorMsg: null,
      errorResponse: null,
      response: "",
      startingOrderStatus: null,
      restrictedSkus: null,
    };
  },
  computed: {},
  components: {
    Button,
  },
  mounted() {
    const order = this.$store.getters["orders/getOrder"];

    this.startingOrderStatus = order.status.Status;

    OrderApi.enforceStateRestrictions(order.OrderNumber)
      .then((response) => {
        if (response.data.body.orderStatus == "RESTRICTED") {
          this.isError = true;
          this.errorMsg = "The following variants are restricted in " + order.ShipState + ":";
          this.invalidItems = response.data.body.invalidItems;
          this.response =
            "The update state restrictions process completed successfully! If the status has changed, please refresh your page to see the results.";
        } else {
          this.response =
            "No state restrictions detected! If the status of the order has changed, please refresh your page to see the results.";
        }
      })
      .catch((e) => {
        this.response = null;
        this.isError = true;
        this.errorMsg =
          "Something has gone wrong with this request. If this issue persists, please contact the dev team.";
        console.error(e.response.data);
      })
      .finally(() => {
        this.saving = false;
      });
  },
  methods: {},
};
</script>
